import { SettingsSort, StarLarge, StarLargeFilled } from '@griply/assets';
import { Skeleton } from '@mui/material';
import { useGoalById } from 'features/goals';
import { useIsFavorite, useToggleFavorite } from 'features/user';
import React, { useRef } from 'react';
import { useParams } from 'react-router';
import { GoalContextMenu } from 'shared/components/connected/goal-context-menu';
import { Colors, IconButton } from 'shared/components/ui/icon-button';
import { useOpenMenu } from 'shared/hooks/use-open-menu';
import { FavoriteType } from 'shared/types/user-settings';

import * as Styled from './page-top-bar.style';

export const LoadingInteractions: React.FC = () => (
  <Skeleton animation="wave" width="6.4rem" height="3.2rem" />
);

export const Interactions: React.FC = () => {
  const interactionsRef = useRef<HTMLDivElement>(null);

  const { id } = useParams();
  const goal = useGoalById(id);
  const isFavorite = useIsFavorite(id);

  const { menuOpen, openMenu, closeMenu } = useOpenMenu();
  const toggleFavorite = useToggleFavorite();

  const onFavorite = () => {
    !!goal && toggleFavorite(goal.id, FavoriteType.Goal);
  };

  return (
    <Styled.Interactions ref={interactionsRef}>
      <IconButton
        icon={isFavorite ? StarLargeFilled : StarLarge}
        onClick={onFavorite}
        color={isFavorite ? Colors.Warning : Colors.Default}
        strokeWidth={2}
        preventDrag
      />

      <IconButton
        icon={SettingsSort}
        onClick={openMenu}
        color={Colors.Default}
        strokeWidth={2}
        // size={Sizes.Medium}
        preventDrag
      />
      {menuOpen && (
        <GoalContextMenu
          id={id!}
          onClose={closeMenu}
          referenceElement={interactionsRef}
        />
      )}
    </Styled.Interactions>
  );
};
